import { render, staticRenderFns } from "./EstadoSaude.vue?vue&type=template&id=24a39586&scoped=true"
import script from "./EstadoSaude.vue?vue&type=script&lang=js"
export * from "./EstadoSaude.vue?vue&type=script&lang=js"
import style0 from "./EstadoSaude.vue?vue&type=style&index=0&id=24a39586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a39586",
  null
  
)

export default component.exports